import { Icon, type IconJVSProps } from '@mairistem/composants';

const AccueilTileIcon = (props: IconJVSProps) => (
  <Icon
    iconSet="Lucide"
    className="colored primary"
    size={35}
    strokeWidth={1.3}
    style={{
      position: 'absolute',
      left: '1em',
      opacity: 0.75,
    }}
    {...props}
  />
);

export default AccueilTileIcon;
